<template>
  <div class="form-elements">
    <div>
        <sp-360-panel :title="'management.rotas.manageRotas' | translate">
            <div class="row">
                <div class="flex lg12 md12 sm12" style="margin-top:1rem;">
                  <v-jsoneditor v-model="rotas" :options="options" :plus="false" height="600px" @error="onError"/>
                  <fieldset>
                      <div class="row">
                        <div class="flex lg6">
                            <va-button type="button" @click="limpar()" class="btn btn-primary btn-sm pull-left">
                              {{'management.revertChanges'| translate}}
                            </va-button>
                        </div>
                        <div class="flex lg6">
                            <va-button type="button" :disabled="isBtnSaveDisabled" @click="alterarRotas()" class="btn btn-primary btn-sm pull-right">
                              {{'management.save'| translate}}
                            </va-button>
                        </div>
                      </div>
                  </fieldset>
                </div>
            </div>
        </sp-360-panel>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import VJsoneditor from 'v-jsoneditor/src/index'
import Multiselect from 'vue-multiselect'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  components: { VJsoneditor, Sp360Panel },
  name: 'rotas',
  computed: {

  },
  data () {
    return {
      isBtnSaveDisabled: true,
      options: {
        onValidationError: function (errors) {
          this.setStatus(errors)
        }.bind(this),
        modes: ['tree', 'code'],
        languages: constantes.JSONEDITOR_LOCALIZACAO
      },
      openModalDelecao: false,
      rotas: {},
      rotasIniciais: {},
      dadoRequest: {},
    }
  },
  beforeCreate () {
    this.$store.dispatch('parametrizacao/getRotasPadraoManagement').then(dado => {
      this.dadoRequest = dado
      this.rotasIniciais = JSON.parse(dado.rotas)
      this.rotas = JSON.parse(dado.rotas)
    })
  },
  methods: {
    onError (error) {
    },
    setStatus (errors) {
      if (errors.length > 0) { this.isBtnSaveDisabled = true } else { this.isBtnSaveDisabled = false }
    },
    showSmallModal () {
      this.$refs.smallModal.open()
    },
    alterarRotas () {
      event.preventDefault()
      let iguais = _.isEqual(this.rotasIniciais, this.rotas)
      if (this.isBtnSaveDisabled) {
        this.showToast(this.$t('management.rotas.invalidJson'), constantes.TOASTED_ERROR)
      } else if (iguais) {
        this.isBtnSaveDisabled = true
        this.showToast(this.$t('management.noChangesDetected'), constantes.TOASTED_ERROR)
      } else {
        this.dadoRequest.rotas = JSON.stringify(this.rotas)
        this.$store.dispatch('parametrizacao/putRotas', this.dadoRequest)
          .then(retorno => {
            this.showToast(this.$t('management.rotas.standardRoute') + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.rotasIniciais = _.cloneDeep(this.rotas)
          })
          .catch(err => {
            console.error(err)
            this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
          })
      }
      this.isBtnSaveDisabled = false
    },
    deletarModal (event) {
      this.privilegioADeletar = event.rowData
      this.openModalDelecao = true
    },
    limpar () {
      this.rotas = this.rotasIniciais
    },
  },
}
</script>
